import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=5978e6b3&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=5978e6b3&prod&scoped=true&lang=css"
import style1 from "./Company.vue?vue&type=style&index=1&id=5978e6b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978e6b3",
  null
  
)

export default component.exports